module.exports = __webpack_public_path__ + "static/media/spinner.c0d53bc0.svg";